<template>
    <section class='viewsrhqyBasicManage_coordinate p-4 space-y-4'>
        <viewTitle title="业务管理 / 基础数据管理 / 基地坐标管理" :showReturn="false" />
        <el-button v-has="['c-base-mp-coordinate-add']" @click="onAdd" size="medium" type="primary">添加</el-button>
        <div class="my-4 space-x-2">
            <span class="text-sm">基地名称</span>
            <el-input clearable v-model="queryParam.name" placeholder="请输入基地名称" class="w-60"></el-input>
        </div>
        <c-table id="coordinateManage" :isIndex="false" :data="dataSource" :columns="columns" :query.sync="pagintion"
            :total="total" @loadPage="loadData">
            <template slot="update_time" slot-scope="scope">
                {{ scope.row.update_time | timeFormat }}
            </template>
            <template slot="action" slot-scope="scope">
                <el-row type="flex" justify="space-around" align="middle">
                    <c-link v-has="['c-base-mp-coordinate-update']" @click="onEdit(scope.row)"
                        label="修改"></c-link>
                    <c-link v-has="['c-base-mp-coordinate-delete']" @click="onDelete(scope.row)" label="删除"
                        type="danger"></c-link>
                </el-row>
            </template>
        </c-table>
        <coordinateModal ref="coordinateModal" @ok="refreshData"></coordinateModal>
    </section>
</template>
<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import coordinateModal from "./components/coordinateModal.vue";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            columns: [
                { label: '基地', prop: 'baseName', formatData: () => this.baseInfo.com_name },
                { label: '坐标', prop: 'coordinate' },
                { label: '坐标名称', prop: 'name' },
                { label: '打卡范围（米）', prop: 'range' },
                { label: '发货打卡范围（米）', prop: 'delivery_range' },
                { 
                    label: '最近维护时间',
                    prop: 'update_time'
                },
                { label: '操作', prop: 'action', width: 120 }
            ],
            fetchDataEvent: (params) => this.$common.http({
                url: "/api/contact/list_coordinate",
                data: params,
            })
        };
    },
    computed: {
        ...mapGetters([
            "baseInfo",
        ]),
    },
    components: {
        coordinateModal
    },
    methods: {
        onAdd() {
            this.$refs.coordinateModal.openModal();
        },
        onEdit(row) {
            this.$refs.coordinateModal.openModal(row);
        },
        onDelete(row) {
            this.$confirm('删除后数据不可恢复！确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning' 
            }).then(() => {
                this.$common.http({
                    url: "/api/contact/delete_coordinate",
                    data: { id: row.id } 
                }).then(() => {
                    this.$message.success("删除成功");
                    this.refreshData();
                })
            });
        },
    },
    mixins: [initListMinxin, mixinTableLyout],
}
</script>
<style lang="less" scope>
@import "../assets/css/common";
</style>
